@if (isConfigurationOk && clientConfig) {
  <div id="page-container"
    class="page-container twpub-config-{{clientConfig.id}}">
    <div id="header-content" class="header-content">
      <pub-header-wrapper></pub-header-wrapper>
    </div>
    <div id="page-content" class="page-content">
      <pub-preamble-wrapper></pub-preamble-wrapper>
      @if (!showSidebar) {
        <div class="block-container">
          <div class="dictionary-language-block">
            <ng-container *ngTemplateOutlet="dictionaryBlock"></ng-container>
            <ng-container *ngTemplateOutlet="languageBlock"></ng-container>
          </div>
          <ng-container *ngTemplateOutlet="searchBlock"></ng-container>
          <ng-container *ngTemplateOutlet="resultBlock"></ng-container>
        </div>
      } @else {
        @if (showSidebar) {
          <div class="sidebar-container">
            <div #sidenav class="sidebar-bar">
              <ng-container *ngTemplateOutlet="dictionaryBlock"></ng-container>
              <div class="filter-separator">
                <span i18n="@@sidebar.filters">Filters</span>
              </div>
              <pub-filter-wrapper></pub-filter-wrapper>
            </div>
            <div class="sidebar-content">
              <div class="block-container">
                <ng-container *ngTemplateOutlet="languageBlock"></ng-container>
                <ng-container *ngTemplateOutlet="searchBlock"></ng-container>
                <ng-container *ngTemplateOutlet="resultBlock"></ng-container>
              </div>
            </div>
          </div>
        }
      }
    </div>
    <div id="footer-content" class="footer-content">
      <pub-footer-wrapper></pub-footer-wrapper>
    </div>
  </div>
}


<ng-template #languageBlock>
  <div class="language-block">
    <pub-source-language-wrapper></pub-source-language-wrapper>
    <pub-target-language-wrapper></pub-target-language-wrapper>
  </div>
</ng-template>

<ng-template #dictionaryBlock>
  <div class="dictionary-block">
    <pub-dictionary-wrapper></pub-dictionary-wrapper>
    <pub-section-wrapper></pub-section-wrapper>
    <pub-domain-wrapper></pub-domain-wrapper>
  </div>
</ng-template>

<ng-template #searchBlock>
  <div class="search-block">
    <pub-search-field-wrapper></pub-search-field-wrapper>
    @if (showSuggestButton) {
      <a href="javascript:void(0)" class="suggest-button"
         (click)="openSuggestDialog()"
         title="Suggest a term" i18n-title="@@suggestion.button">
        <mat-icon>lightbulb</mat-icon>
      </a>
    }
  </div>
</ng-template>

<ng-template #resultBlock>
  <div class="result-block">
    <pub-result-list-wrapper></pub-result-list-wrapper>
  </div>
</ng-template>
